/*
 * Module for the Benefits section of Account Overview
*/

rs.module("ui/content/account/overview/benefits",

    ["ui/framework/client-templates"],

    function (clientTemplates) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, codeValues, pendingBenefitTemplateKey) {

            // Update the benefit detail based on the selected benefit
            $.js(jsSelectors.benefitSelect, { required: false }).change(function () {

                var valuesArray = $(this).val().split("|");
                var benefitClaimPaymentKey = valuesArray[0];
                var benefitStatus = valuesArray[1];
                var benefitType = valuesArray[2]

                if (benefitStatus == codeValues.pending) {

                    $.js(jsSelectors.benefitBreakdown).html(clientTemplates.render(pendingBenefitTemplateKey, { benefitType: benefitType }));
                }
                else {
                    $.get(
                        backendUrls.getBenefitBreakdown,
                        {
                            benefitClaimPaymentKey: benefitClaimPaymentKey
                        })
                        .done(function (html) {
                            $.js(jsSelectors.benefitBreakdown).html(html);
                        });
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);